// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2LATZ","left":"StickyBox_left__3KYsm","right":"StickyBox_right__2eHIX"};